'use client'

import { CookieSettingsSection } from './sections/cookie-settings-section'

export const PrivacyTab = () => {
    return (
        <div className="flex flex-col gap-6">
            <CookieSettingsSection />
        </div>
    )
}
